import { useEffect, useRef } from "react";

export function useAdminIdle(onIdle: () => void, ms = 3_600_000) {
  const callback = useRef(onIdle);
  callback.current = onIdle;
  useEffect(() => {
    let timer: ReturnType<typeof setTimeout>;
    const reset = () => {
      clearTimeout(timer);
      timer = setTimeout(() => callback.current(), ms);
    };
    const events = ["pointerdown", "keydown", "touchstart", "wheel"];
    for (const event of events)
      window.addEventListener(event, reset, { passive: true });
    reset();
    return () => {
      clearTimeout(timer);
      for (const event of events) window.removeEventListener(event, reset);
    };
  }, [ms]);
}
